import * as Yup from 'yup';

export const lenderRankSchema = Yup.object().shape({
  rank: Yup.number()
    .required()
    .test('Is positive?', 'The number must be greater than 0!', (value) => (value as number) > 0),
  subRank: Yup.number().nullable(),
});
